<template>
  <div class="hamburger-loader">
    <div class="bun-top" />
    <div class="seeds" id="seeds" />
    <div class="tomato" />
    <div class="lettuce" />
    <div class="cheese" />
    <div class="patty" />
    <div class="bun-bottom" />
  </div>
</template>

<style scoped>
.hamburger-loader {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 50px auto;
}

.hamburger-loader > div {
  position: absolute;
  left: 0;
  top: -20px;
  opacity: 0;
  width: 100%;
}

.hamburger-loader-text {
  color: rgb(var(--v-theme-on-surface));
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}

.bun-top {
  background-color: #f5b042;
  height: 32px;
  border-radius: 32px 32px 5px 5px;
  animation: drop-top 4.5s linear infinite;
  animation-delay: 0.2s;
  position: relative;
}

#seeds {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 32px 32px 15px 15px;
  background-color: #fff5e0;
  width: 4px;
  height: 6px;
  left: 15px;
  border-radius: 45%;
  box-shadow:
    15px -2px 0 #fff5e0,
    30px 0px 0 #fff5e0,
    45px -1px 0 #fff5e0,
    20px 8px 0 #fff5e0,
    40px 6px 0 #fff5e0;
  animation: drop-seeds 4.5s linear infinite;
  animation-delay: 0.2s;
}

.tomato {
  background-color: #ff6b6b;
  height: 8px;
  border-radius: 15px;
  animation: drop-tomato 4.5s linear infinite;
  animation-delay: 0.2s;
}

.lettuce {
  background-color: #3dc851;
  height: 10px;
  border-radius: 15px;
  animation: drop-lettuce 4.5s linear infinite;
  animation-delay: 0.2s;
}

.cheese {
  background-color: #ffc72c;
  height: 6px;
  border-radius: 10px;
  animation: drop-cheese 4.5s linear infinite;
  animation-delay: 0.2s;
}

.patty {
  background-color: #7a4b36;
  height: 14px;
  border-radius: 15px;
  animation: drop-patty 4.5s linear infinite;
  animation-delay: 0.2s;
}

.bun-bottom {
  background-color: #f5b042;
  height: 10px;
  border-radius: 2px 2px 4px 4px;
  animation: drop-bottom 4.5s linear infinite;
  animation-delay: 0.2s;
}

@keyframes drop-bottom {
  0%,
  10% {
    top: -20px;
    opacity: 0;
  }
  15%,
  80% {
    opacity: 1;
    top: 66px;
  }
  90%,
  100% {
    opacity: 0;
    top: 66px;
  }
}

@keyframes drop-patty {
  0%,
  20% {
    top: -20px;
    opacity: 0;
  }
  25%,
  80% {
    opacity: 1;
    top: 52px;
  }
  90%,
  100% {
    opacity: 0;
    top: 52px;
  }
}

@keyframes drop-cheese {
  0%,
  30% {
    top: -20px;
    opacity: 0;
  }
  35%,
  80% {
    opacity: 1;
    top: 46px;
  }
  90%,
  100% {
    opacity: 0;
    top: 46px;
  }
}

@keyframes drop-lettuce {
  0%,
  40% {
    top: -20px;
    opacity: 0;
  }
  45%,
  80% {
    opacity: 1;
    top: 36px;
  }
  90%,
  100% {
    opacity: 0;
    top: 36px;
  }
}

@keyframes drop-tomato {
  0%,
  50% {
    top: -20px;
    opacity: 0;
  }
  55%,
  80% {
    opacity: 1;
    top: 28px;
  }
  90%,
  100% {
    opacity: 0;
    top: 28px;
  }
}

@keyframes drop-top {
  0%,
  60% {
    top: -20px;
    opacity: 0;
  }
  65%,
  80% {
    opacity: 1;
    top: -4px;
  }
  90%,
  100% {
    opacity: 0;
    top: -4px;
  }
}

@keyframes drop-seeds {
  0%,
  60% {
    top: -20px;
    opacity: 0;
  }
  65%,
  80% {
    opacity: 1;
    top: 4px;
  }
  90%,
  100% {
    opacity: 0;
    top: 4px;
  }
}
</style>
